// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-4DM","colBig":"styles_colBig__3D1Mj","colSmall":"styles_colSmall__3AF_b"};